export const MIXPANEL_PROJECT_TOKEN =
  process.env.NEXT_PUBLIC_MIXPANEL_PROJECT_TOKEN;
export const MIXPANEL_HOST_NAME = process.env.NEXT_PUBLIC_MIXPANEL_HOST_NAME;
export const MIXPANEL_PROXY = process.env.NEXT_PUBLIC_MIXPANEL_PROXY;
